<script setup lang="ts">
import { useEventListener } from '@vueuse/core';
import { useAuthTransition } from '~/composables/use-auth-transition';

const { isExpanding, collapse } = useAuthTransition();

// A page restored from the back/forward cache still has the expanded state it was left in.
useEventListener(window, 'pageshow', (event) => {
	if (event.persisted) collapse();
});
</script>

<template>
	<div class="relative flex h-dvh w-full">
		<div
			class="absolute inset-y-0 z-1 bg-dimmed transition-all duration-base ease-out"
			:class="isExpanding ? 'w-full' : 'w-full lg:w-1/2 2xl:w-1/3'"
		/>
		<div class="relative z-2 flex w-full flex-col overflow-y-auto lg:w-1/2 2xl:w-1/3">
			<div
				class="flex min-h-full flex-col p-6 transition-all duration-fast lg:p-12"
				:class="isExpanding && 'opacity-0 blur-sm'"
			>
				<AuthHeader />

				<div class="flex flex-1 flex-col justify-center py-12">
					<section class="mx-auto w-full max-w-md space-y-8">
						<slot />
					</section>
				</div>
			</div>
		</div>

		<div class="relative z-0 hidden w-1/2 lg:flex 2xl:w-2/3">
			<AuthPanel />
		</div>
	</div>
</template>

<style>
/* Prevent overscroll on MacOS */
html, body {
	overflow: hidden;
}
</style>
